import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube, MapPin, Mail, Phone, MessageCircle } from 'lucide-react';
// Logo path is /Images/paoz.png in public folder
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container footer-grid">
                <div className="footer-col">
                    <img src="/Images/paoz.png" alt="PAOZ HCC Logo" className="footer-logo" />
                    <p>
                        PAOZ Hope Community Church<br />
                        To know Christ, to make Him known, and to change the world.
                    </p>
                    <div className="social-group">
                        <span className="social-label">Connect with us</span>
                        <div className="social-links">
                            <a href="https://www.facebook.com/Paozhcc" target="_blank" rel="noreferrer" title="Facebook" className="social-btn">
                                <Facebook size={18} />
                            </a>
                            <a href="https://www.instagram.com/paoz_hope_community_church?igsh=ajJ0NGt0NGR2Yndq" target="_blank" rel="noreferrer" title="Instagram" className="social-btn">
                                <Instagram size={18} />
                            </a>
                            <a href="https://www.youtube.com/@PAOZHCC" target="_blank" rel="noreferrer" title="YouTube" className="social-btn">
                                <Youtube size={18} />
                            </a>
                            <a href="https://whatsapp.com/channel/0029VaoEAODE50UoeVr9sg2w" target="_blank" rel="noreferrer" title="WhatsApp Channel" className="social-btn">
                                <MessageCircle size={18} />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="footer-col">
                    <h3>Quick Links</h3>
                    <ul>
                        <li><Link to="/about">About Us</Link></li>
                        <li><Link to="/ministries">Ministries</Link></li>
                        <li><Link to="/contact">Contact & Locations</Link></li>
                        <li><Link to="/give">Give</Link></li>
                    </ul>
                </div>

                <div className="footer-col">
                    <h3>Contact Us</h3>
                    <ul className="contact-list">
                        <li>
                            <MapPin size={24} style={{ flexShrink: 0 }} />
                            <span>10 Good Hope Westgate, Harare, Zimbabwe</span>
                        </li>
                        <li>
                            <Mail size={18} />
                            <span>Paozhcc@gmail.com</span>
                        </li>
                        <li>
                            <Phone size={18} />
                            <span>+263 77 167 4344</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} PAOZ Hope Community Church. All rights reserved.</p>
                <p className="footer-signature">Designed and developed by <a href="https://kodebuildtech.com/" target="_blank" rel="noopener noreferrer">Kodebuild</a></p>
            </div>
        </footer>
    );
};

export default Footer;
